<div class="row justify-start items-center gap-8 my-8">
  <app-skeleton-loader [width]="_avatarWidth" [height]="_avatarHeight" [circle]="isCircle"></app-skeleton-loader>
  <div class="flex-1">
    <app-skeleton-loader [width]="_titleWidth" [height]="_titleHeight" className="mb-4"></app-skeleton-loader
    ><app-skeleton-loader [width]="_titleWidth" [height]="_titleHeight" className="mb-4"></app-skeleton-loader>
  </div>
</div>
